module.exports = __webpack_public_path__ + "img/yhgl.84013e71.svg";